import axios from 'axios'

export const baseURL = '/api'

export const repository = axios.create({ baseURL })

const createErrorInterceptor = (repository) => {
  repository.interceptors.response.use(undefined, async (error) => {
    return Promise.reject(error.response)
  })
}

[repository].forEach(rep => createErrorInterceptor(rep))
